let cartBarSelecter = '.cart__header .cart__title.h1';
let drawerBarSelecter = '#CartDrawer .drawer__body.flex-grow.v-scrollable.flex.flex-col';
let storeHasDrawer = true;
let tierStartWithZero = false;
const layoutSetting = globalFieldsSub?.progressBarMetafield?.layout_setting;
const isProgressBarEnabled = globalFieldsSub?.progressBarMetafield?.progressBar_enable_disable;
let hasTierMin = false;
let progressBarDisplayPreferences = layoutSetting?.displayPreferences === 'Encouragement_Message';

function getSelecters(placeToShow) {
  let classSelecter = placeToShow == 'drawer' ? `-${placeToShow}` : placeToShow
  let progressBar = layoutSetting?.progressBarName
        let progressBarSelectorMap = {
          gradientProgressBar:{   
              container: `progress-bar-container${classSelecter}-2`,
              bar: `progress-bar${classSelecter}-2`,
              line: `progress-bar__line${classSelecter}-2`,
              fill: `progress-bar__fill${classSelecter}-2`,
              milestones: `milestones${classSelecter}-2`,
              milestonelabels: `milestone__labels${classSelecter}-2`,
              heading: `progress-bar-heading${classSelecter}`,
              milestone: `milestone${classSelecter}-2`,
              circle: `milestone__circle${classSelecter}-2`,
              label: `milestone__label${classSelecter}-2`,
              icon : `<i class="ri-truck-line"></i>`
          },
          classicProgressBar:{   
              container: `progress-bar-container${classSelecter}-1`,
              bar: `progress-bar${classSelecter}-1`,
              line: `progress-bar__line${classSelecter}-1`,
              fill: `progress-bar__fill${classSelecter}-1`,
              milestones: `milestones${classSelecter}-1`,
              milestonelabels: `milestone__labels${classSelecter}-1`,
              heading: `progress-bar-heading${classSelecter}`,
              milestone: `milestone${classSelecter}-1`,
              circle: `milestone__circle${classSelecter}-1`,
              label: `milestone__label${classSelecter}-1`,
              icon : `<i class=""></i>`
          },
          defaultProgressBar:{   
              container: `progress-bar-container${classSelecter}`,
              bar: `progress-bar${classSelecter}`,
              line: `progress-bar__line${classSelecter}`,
              fill: `progress-bar__fill${classSelecter}`,
              milestones: `milestones${classSelecter}`,
              milestonelabels: `milestone__labels${classSelecter}`,
              heading: `progress-bar-heading${classSelecter}`,
              milestone: `milestone${classSelecter}`,
              circle: `milestone__circle${classSelecter}`,
              label: `milestone__label${classSelecter}`,
              icon : `<i class="ac_svg_icon"><svg
                                width="18" height="18" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M0.122513 10.8159C0.409513 11.8189 1.18251 12.5909 2.72751 14.1359L4.55751 15.9659C7.24751 18.6569 8.59151 19.9999 10.2615 19.9999C11.9325 19.9999 13.2765 18.6559 15.9655 15.9669C18.6555 13.2769 19.9995 11.9329 19.9995 10.2619C19.9995 8.59187 18.6555 7.24687 15.9665 4.55787L14.1365 2.72787C12.5905 1.18287 11.8185 0.409866 10.8155 0.122866C9.81251 -0.165134 8.74751 0.0808662 6.61851 0.572866L5.39051 0.855866C3.59851 1.26887 2.70251 1.47587 2.08851 2.08887C1.47451 2.70187 1.26951 3.59987 0.855513 5.39087L0.571513 6.61887C0.080513 8.74887 -0.164487 9.81287 0.122513 10.8159ZM8.12151 5.27087C8.31439 5.45687 8.46827 5.67944 8.57417 5.92558C8.68006 6.17172 8.73586 6.4365 8.73829 6.70444C8.74071 6.97238 8.68973 7.23812 8.58831 7.48614C8.48689 7.73416 8.33707 7.95948 8.1476 8.14896C7.95813 8.33843 7.73281 8.48825 7.48479 8.58967C7.23677 8.69108 6.97103 8.74207 6.70309 8.73964C6.43514 8.73721 6.17037 8.68142 5.92423 8.57552C5.67809 8.46962 5.45552 8.31574 5.26951 8.12287C4.90257 7.74237 4.69966 7.23303 4.70445 6.70444C4.70924 6.17585 4.92135 5.67027 5.29513 5.29649C5.66892 4.9227 6.1745 4.7106 6.70309 4.7058C7.23167 4.70101 7.74101 4.90392 8.12151 5.27087ZM17.0495 10.0509L10.0705 17.0309C9.929 17.1674 9.73951 17.2429 9.54286 17.2411C9.34621 17.2393 9.15814 17.1604 9.01915 17.0212C8.88016 16.8821 8.80137 16.694 8.79976 16.4973C8.79814 16.3007 8.87383 16.1113 9.01051 15.9699L15.9885 8.98987C16.1292 8.84917 16.32 8.77013 16.519 8.77013C16.718 8.77013 16.9088 8.84917 17.0495 8.98987C17.1902 9.13056 17.2693 9.32139 17.2693 9.52037C17.2693 9.71934 17.1902 9.91017 17.0495 10.0509Z"
                                    fill="white" />
                            </svg></i>`
          }
      };

  return progressBarSelectorMap[progressBar]
}



const handleProgressBar = (action) => {
  hasTierMin = globalFieldsSubtotalCartPage_AC?.cartSubTotalMetafield?.tier_min?.length > 0
  if (action === 'create') createProgressBarTwo(layoutSetting);
  else if (action === 'update') updateProgressBarTwo(layoutSetting);
  else console.warn(`Invalid action: ${action}`);
};

// if (isProgressBarEnabled && hasTierMin) handleProgressBar("create");

function progressBarMain() {
    hasTierMin = globalFieldsSubtotalCartPage_AC ? globalFieldsSubtotalCartPage_AC?.cartSubTotalMetafield?.tier_min?.length > 0 : false;
  const drawerSelectors = [
    ".progress-bar-container-drawer",
    ".progress-bar-container-drawer-1",
    ".progress-bar-container-drawer-2",
  ];

   drawerBarSelecter == document.querySelector(`${drawerBarSelecter}`);
  const foundDrawer = drawerSelectors.find(sel => document.querySelector(sel));

  if (!foundDrawer && drawerBarSelecter && isProgressBarEnabled && hasTierMin) {
    handleProgressBar("create");
  }

  if (isProgressBarEnabled && hasTierMin) {
    handleProgressBar("update");
  }

  if (globalFieldsSubtotalCartPage_AC?.cartObj?.items.length === 0) {
    [
      ".progress-bar-container",
      ".progress-bar-container-1",
      ".progress-bar-container-2",
      ...drawerSelectors,
    ].forEach(selector => {
      const el = document.querySelector(selector);
      if (el) el.remove();
    });
  }

  if (progressBarDisplayPreferences) {
    $('.progress-bar_Main').hide()
  }
}




function isInAnyRange(compareQuantity, tierMin, tierMax) {
    for (let i = 0; i < tierMin.length; i++) {
      const min = parseFloat(tierMin[i], 10);
      const max = tierMax[i] === "max" ? Infinity : parseFloat(tierMax[i], 10);
  
      if (compareQuantity >= min && compareQuantity <= max) {
        return true; // Found a range that includes compareQuantity
      }
    }
    return false; // No range matched
  }

  function suggestQuantityForDiscount( compareQuantity, tierMin, tierMax, tierValues, discount_type, discountBasedOn) {
    let message = null;

    let shopLanguage = zermatusaGetCurrentLanguage();
    console.log('shopLanguage', shopLanguage);

    /*
    console.log('suggestQuantityForDiscount compareQuantity', compareQuantity);
    console.log('suggestQuantityForDiscount tierMin', tierMin);
    console.log('suggestQuantityForDiscount tierMax', tierMax);
    console.log('suggestQuantityForDiscount tierValues', tierValues);
    console.log('suggestQuantityForDiscount discount_type', discount_type);
    console.log('suggestQuantityForDiscount discountBasedOn', discountBasedOn);
    */
    let positionTierValue = 0;
    let positionTier = '';
    let positionTierMessage = null;
    let additionalQuantityTier = 0;
  
    for (let i = 0; i < tierMin.length; i++) {
      positionTierValue = i;
      //console.log('suggestQuantityForDiscount positionTierValue', positionTierValue);
      const min = parseFloat(tierMin[i], 10);
      const max = tierMax[i] === "max" ? Infinity : parseFloat(tierMax[i], 10);
  
      // Check if compareQuantity is within the current tier range
      if (compareQuantity >= min && compareQuantity <= max) {
        //console.log('suggestQuantityForDiscount entro a if (compareQuantity >= min && compareQuantity <= max)');
        const nextTierIndex = i + 1;
        positionTierValue = nextTierIndex;
        //console.log('suggestQuantityForDiscount positionTierValue', positionTierValue);
  
        if (nextTierIndex < tierMin.length) {
          //console.log('suggestQuantityForDiscount entro a if (nextTierIndex < tierMin.length)');
          const nextMin = parseFloat(tierMin[nextTierIndex], 10);
          const additionalQuantity = nextMin - compareQuantity;
          additionalQuantityTier = additionalQuantity;
  
          // Determine the message based on discount type and discount based on
          message = discountBasedOn === "Range of Amount Spent" ? `Invierte ${globalFieldsSub.amount.replace( /\{\{.*?\}\}/g, additionalQuantity.toFixed(2) )} ` : `Invierte ${additionalQuantity} unidades`;
  
          if (discount_type === "percentage") {
            message = `${message} y recibe un ${tierValues[nextTierIndex]}% Off Total `;
          } else if (discount_type === "fixed") { 
            message = `${message} y recibe un ${globalFieldsSub.amount.replace( /\{\{.*?\}\}/g, tierValues[nextTierIndex] )} Total `;
          }
        } else {
          positionTierValue = tierMin.length;
          //console.log('suggestQuantityForDiscount positionTierValue', positionTierValue);
          if (discount_type === "percentage") {
            // message = `Felicidades! ¡Obtuviste un descuento exclusivo del  ${tierValues[i === 0 ? i + 1 : i]}% Off `;
             message = `Ya tienes ${tierValues[i]}% Off! Aplicalo en mas productos`;
          } else {
            const discountAmount = tierValues[i];
            message = `Ya tienes ${tierValues[i]} Off! Aplicalo en mas productos`;
          }
        }
        break;
      }
    }
  
    // If compareQuantity is below the lowest range
    // let firstIndexValue = tierStartWithZero ? 1 :0 ;
    let firstIndexValue = 0 ;
    // let firstIndexValue =  ;
    if (!message && compareQuantity < parseFloat(tierMin[firstIndexValue], 10)) {
      const additionalQuantity = parseFloat(tierMin[firstIndexValue], 10) - compareQuantity;
      additionalQuantityTier = additionalQuantity;
      positionTierValue = firstIndexValue;
      //console.log('suggestQuantityForDiscount positionTierValue', positionTierValue);
  
      message = discountBasedOn === "Range of Amount Spent" ? `Invierte ${globalFieldsSub.amount.replace( /\{\{.*?\}\}/g,additionalQuantity.toFixed(2))}`: `Invierte ${additionalQuantity} unidades`;
  
      if (discount_type === "percentage") {
        message = `${message} y recibe un ${tierValues[firstIndexValue]}% Off Total `;
      } else if (discount_type === "fixed") {
        // const discountAmount = (tierValues[firstIndexValue] / 100) * compareQuantity;
        const discountAmount = tierValues[firstIndexValue];
        message = `${message} y recibe un ${globalFieldsSub.amount.replace( /\{\{.*?\}\}/g, discountAmount )} Off Total `;
      }
    }

    if (positionTierValue == 0) {
      positionTier = 'NoDiscount';
    } else if (positionTierValue >= 1 && positionTierValue <= (tierMin.length - 2)) {
      positionTier = 'DiscountTier1';
    } else if (positionTierValue <= (tierMin.length - 1)) {
      positionTier = 'DiscountTier2';
    } else {
      positionTier = 'MaxDiscount';
    }

    if (discountBasedOn === "Range of Amount Spent") {
      if (positionTier === 'NoDiscount') {
        if (shopLanguage == 'es')
          positionTierMessage = `Por poco! Agrega el equivalente a ${globalFieldsSub.amount.replace( /\{\{.*?\}\}/g, additionalQuantityTier.toFixed(2) )} en productos para acceder a nuestro primer nivel de descuento`;  
        else
          positionTierMessage = `Almost there! Add items worth ${globalFieldsSub.amount.replace( /\{\{.*?\}\}/g, additionalQuantityTier.toFixed(2) )} to unlock our first discount`;  
      }
      else if (positionTier === 'DiscountTier1') {
        if (shopLanguage == 'es')
          positionTierMessage = `Excelente -- agrega ${globalFieldsSub.amount.replace( /\{\{.*?\}\}/g, additionalQuantityTier.toFixed(2) )} más para acceder a un nivel de descuento mayor`;  
        else
          positionTierMessage = `Keep going -- add ${globalFieldsSub.amount.replace( /\{\{.*?\}\}/g, additionalQuantityTier.toFixed(2) )} more to unlock a huge discount`;  
      }
      else if (positionTier === 'DiscountTier2') {
        if (shopLanguage == 'es')
          positionTierMessage = `Sigue asi!, ya solo te faltan ${globalFieldsSub.amount.replace( /\{\{.*?\}\}/g, additionalQuantityTier.toFixed(2) )} para obtener nuestro maximo nivel de descuento`;  
        else
          positionTierMessage = `The best deal is almost yours -- just ${globalFieldsSub.amount.replace( /\{\{.*?\}\}/g, additionalQuantityTier.toFixed(2) )} more to unlock our biggest discount`;  
      }
      else {
        if (shopLanguage == 'es')
          positionTierMessage = `Lo hiciste!, muchas felicidades, completa tu compra para que disfrutes de tus productos`;
        else
          positionTierMessage = `You did it! You've just made the smartest investment -- checkout and enjoy your deal`;
      }
    } else {
        if (shopLanguage == 'es')
          positionTierMessage = `Agrega productos al carrito para obtener descuentos`;
        else
          positionTierMessage = `Add products to cart to get a discount`;
    }

    //console.log('suggestQuantityForDiscount positionTierValue final', positionTierValue);
    //console.log('suggestQuantityForDiscount positionTier', positionTier);
    //console.log('suggestQuantityForDiscount positionTierMessage', positionTierMessage);
    message = positionTierMessage;
  
    // If no valid suggestion found
    if (!message) {
      if (shopLanguage == 'es')
        positionTierMessage = `Agrega productos al carrito para obtener descuentos`;
      else
        positionTierMessage = `Add products to cart to get a discount`;
    }
  
    // Update progress bar heading with the message
    const progressBarHeading = document.querySelector(".progress-bar-heading");
    const progressBarHeadingDrawer = document.querySelector(".progress-bar-heading-drawer");
    if (progressBarHeading && message) {
      progressBarHeading.textContent = message;
    }
  
    if (progressBarHeadingDrawer && message) {
      progressBarHeadingDrawer.textContent = message;
    }
  }

function checkEligibleItemsForDiscount() {
  const items = globalFieldsSubtotalCartPage_AC.cartTiersArray || [];
  const eligibleItems = items.filter(item => !item.is_exclude);
  const excludeItems = items.filter(item => item.is_exclude);

  const allVariantItemQty = eligibleItems.reduce((sum, item) => sum + item.item.quantity, 0);

  let eligibleSubtotal = globalFieldsSubtotalCartPage_AC?.cartObj?.original_total_price || 0;

  excludeItems.forEach(( exclude ) => {
    if (exclude.is_exclude) {
    let price = exclude.item.original_line_price;
    eligibleSubtotal -= price;
    }else{
     let price = exclude.item.final_line_price || exclude.item.original_line_price;
    eligibleSubtotal -= price;
    }

  });

    let customerSpendAmount = Number(globalFieldsSub.customerSpendAmount)
    if(!customerSpendAmount)0
  eligibleSubtotal = globalFieldsSub.ConvertToFixedDecimalNumber((eligibleSubtotal / 100)+customerSpendAmount);

  return { allVariantItemQty, eligibleSubtotal };
}


  // progress bar two

function  createProgressBarTwo(progressBarCss){
  createProgressBarCommonTwo(progressBarCss,'')
  if (storeHasDrawer) {
  createProgressBarCommonTwo(progressBarCss,'drawer')
  }
  
}
  
  function createProgressBarCommonTwo(progressBarCss,placeToShow) {
   // createProgressBarTwoDrawer(progressBarCss);
      const progressBarSelectorMap = getSelecters(placeToShow)
    let finalSelecterFOrBar = placeToShow == 'drawer' ? drawerBarSelecter : cartBarSelecter
    const cartItemsContainer = document.querySelector(`${finalSelecterFOrBar}`);
    const tiers = globalFieldsSubtotalCartPage_AC.cartSubTotalMetafield;
  
    if (cartItemsContainer ) {
      let progressBarContainer = document.querySelector(`.${progressBarSelectorMap.container}`);
      if (!progressBarContainer) {
        progressBarContainer = document.createElement("div");
        progressBarContainer.classList.add(`${progressBarSelectorMap.container}`);
         placeToShow == 'drawer' ? cartItemsContainer.prepend(progressBarContainer) :cartItemsContainer.after(progressBarContainer,cartItemsContainer);
        
      }
  
      progressBarContainer.innerHTML = `
      <div class="progress-bar_Main">
       <div class="${progressBarSelectorMap.milestonelabels}" style="${
          progressBarCss.showDiscountValue ? "" : "display: none;"
        }"></div>
        <div class="${progressBarSelectorMap.bar} ${placeToShow != 'drawer' ? "cart" : ""}">
          <div class="${progressBarSelectorMap.line}">
            <span class="${progressBarSelectorMap.fill}"></span>
          </div>
          <div class="${progressBarSelectorMap.milestones}"></div>
        </div>
       
        </div>
      `;

      // Apply dynamic styles to the heading using JavaScript
  
      const progressBarHeading = document.createElement("div");
      progressBarHeading.classList.add(`${progressBarSelectorMap.heading}`);
      progressBarHeading.textContent = ""; // Set heading content
  
      // Add the heading based on `discountLabelPosition`
      if (progressBarCss.discountLabelPosition === "below") {
        progressBarContainer.appendChild(progressBarHeading); // Insert heading at the end
      } else {
        progressBarContainer.insertBefore(
          progressBarHeading,
          progressBarContainer.firstChild
        ); // Insert heading at the beginning
      }
  
      const progressBarFillLine = progressBarContainer.querySelector( `.${progressBarSelectorMap.fill}`);
  
      progressBarFillLine.style.background = progressBarCss.fillProgressBarLineColor;
      if (progressBarHeading) {
        if (progressBarCss.showHeading) {
          progressBarHeading.style.color = progressBarCss.headingFontColor;
          progressBarHeading.style.fontSize = `${progressBarCss.headingFontSize}px`;
          progressBarHeading.style.fontWeight = progressBarCss.headingFontWeight;
        } else {
          progressBarHeading.style.display = "none";
        }
      }
  
      const milestonesContainer = progressBarContainer.querySelector(`.${progressBarSelectorMap.milestones}`);
      progressBarContainer.querySelector( `.${progressBarSelectorMap.line}`).style.backgroundColor = progressBarCss.emptyProgressBarLineColor;
      progressBarContainer.querySelector(`.${progressBarSelectorMap.fill}`).style.backgroundColor = progressBarCss.fillProgressBarLineColor;
       

      const tierValues = [ ...tiers.tier_values];
      const totalMilestones = tierValues.length;
  
      // Add milestones
      tierValues.forEach((milestone, index) => {
        const milestoneElement = document.createElement("div");
        milestoneElement.classList.add(`${progressBarSelectorMap.milestone}`);
  
        const leftPosition = totalMilestones > 1 ? (index / (totalMilestones - 1)) * 100 : 100;
        milestoneElement.style.left = `${leftPosition}%`;
  
        milestoneElement.innerHTML = ` <div class="${progressBarSelectorMap.circle}"></div>`;
        milestoneElement.querySelector(`.${progressBarSelectorMap.circle}`).style.background =
          progressBarCss.emptyProgressBarLineColor;
  
        const milestoneLabel = document.createElement("div");
        milestoneLabel.classList.add(`${progressBarSelectorMap.label}`);
        milestoneLabel.style.color = progressBarCss.textFontColor;
        milestoneLabel.style.fontSize =  placeToShow == 'drawer' ?  `${Math.min(progressBarCss.textFontSize,16)}px`:`${progressBarCss.textFontSize}px`;
        milestoneLabel.style.fontWeight = progressBarCss.textFontWeight;

  
        // Set the inner HTML or text content of the milestoneLabel
        //milestoneLabel.innerHTML = `${ tiers.discount_type != "percentage" ? <span class="ac-dicountamount">globalFieldsSub.amount.replace(/\{\{.*?\}\}/g, milestone): milestone}${tiers.discount_type == "percentage" ? "%</span> <span class='ac-discount-off'>OFF<span>": " <span class='ac-discount-off'>OFF<span>"}`;
        // milestoneLabel.innerHTML = tiers.discount_type !== "percentage"
        // ? `<span class='ac-discountamount ac-discount'>${globalFieldsSub.amount.replace(/\{\{.*?\}\}/g, milestone)}</span><span class='ac-discount-off' style="color: rgb(172 167 167) !important;font-family: fantasy;">OFF</span>`
        // : `<span class='ac-discountamount ac-discount'>${milestone}%</span> <span class='ac-discount-off'  style="color: rgb(172 167 167) !important;font-family: fantasy;">OFF</span>`;

        milestoneLabel.innerHTML = tiers.discount_type !== "percentage"
        ? `<span class='ac-discountamount ac-discount'>${globalFieldsSub.amount.replace(/\{\{.*?\}\}/g, milestone)}</span><span class='ac-discount-off'">OFF</span>`
        : `<span class='ac-discountamount ac-discount'>${milestone}%</span> <span class='ac-discount-off'">OFF</span>`;

        // Append the milestoneLabel to the progressBarContainer
        progressBarContainer.querySelector(`.${progressBarSelectorMap.milestonelabels}`).appendChild(milestoneLabel);milestonesContainer.appendChild(milestoneElement);
        let milestone__labels = document.querySelectorAll(`.${progressBarSelectorMap.label} .ac-discountamount`);
        milestone__labels[index].style.background = progressBarCss.emptyProgressBarLineColor;
      });
    }
  
    const labels = document.querySelectorAll(`.${progressBarSelectorMap.label}`);
  
    labels.forEach((label) => {
      label.style.color = layoutSetting.textFontColor;
      label.style.fontSize = placeToShow == 'drawer' ?  `${Math.min( progressBarCss.textFontSize, 16 )}px` : layoutSetting.textFontSize;
    });
  
    const mediaQuery = window.matchMedia("(max-width: 700px)");
  
    // Function to apply or reset styles based on the screen width
    const applyStyles = () => {
      const labels = document.querySelectorAll(`.${progressBarSelectorMap.label}`);
      const progressBarHeading = document.querySelector(`.${progressBarSelectorMap.heading}`);
  
      if (mediaQuery.matches) {
        // Apply styles for screens below 700px
        labels.forEach((label) => {
          label.style.fontSize = "8px";
        });
  
        if (progressBarHeading) {
          progressBarHeading.style.fontSize = "12px";
        }
      } else {
        // Reset styles for screens above 700px
        labels.forEach((label) => {
          label.style.fontSize = placeToShow == 'drawer' ? `${Math.min(progressBarCss.textFontSize,16)}px` : `${progressBarCss.textFontSize}px`; // Reset to original CSS
        });
  
        if (progressBarHeading) {
          progressBarHeading.style.fontSize = placeToShow == 'drawer' ? `${Math.min(progressBarCss.headingFontSize,16)}px` : `${progressBarCss.headingFontSize}px`; // Reset to original CSS
        }
      }
    };
  
    // Call the function initially to apply styles
    applyStyles();
  
    // Listen for changes in screen width and apply styles dynamically
    mediaQuery.addEventListener("change", applyStyles);
  }

function   updateProgressBarTwo(progressBarCss){
  updateProgressBarTwoCommon(progressBarCss,'')
  if (storeHasDrawer) {
  updateProgressBarTwoCommon(progressBarCss,'drawer')
  }
  
}

  function updateProgressBarTwoCommon(progressBarCss,placeToShow) {
    
    const progressBarSelectorMap = getSelecters(placeToShow)
    // updateProgressBarTwoDrawer(progressBarCss);
    const tiers = globalFieldsSubtotalCartPage_AC.cartSubTotalMetafield;
    const cartObj = globalFieldsSubtotalCartPage_AC.cartObj;
    let EligibleItemsForDiscount = checkEligibleItemsForDiscount()
    const subtotalPrice = EligibleItemsForDiscount.eligibleSubtotal;
    const allVariantItemQty = EligibleItemsForDiscount.allVariantItemQty;
    
    const compareQuantity = tiers.DiscountBasedOn === "Range of Amount Spent" ? subtotalPrice : allVariantItemQty;
  
    const progressBarFill = document.querySelector(`.${progressBarSelectorMap.fill}`);
    const milestones = document.querySelectorAll(`.${progressBarSelectorMap.milestone}`);
    const milestone__labels = document.querySelectorAll(`.${progressBarSelectorMap.label} .ac-discount`);
    
    let tierValues = tiers.tier_values;
    let tierMin = tiers.tier_min;
    let tierMax = tiers.tier_max;
    if (tiers.tier_min[0] > 0) {
      tierStartWithZero = false
     tierValues = [ ...tiers.tier_values];
     tierMin = [ ...tiers.tier_min];
     tierMax = [ ...tiers.tier_max];
    }
  
    if (progressBarFill && milestones.length) {
      let progressFillWidth = 0;
  
      // Calculate progress fill width
            milestones.forEach((milestone, milestoneindex) => {
              const milestoneCircle = milestone.querySelector(`.${progressBarSelectorMap.circle}`);
              milestoneCircle.style.background = progressBarCss.emptyProgressBarLineColor;
              milestone__labels[milestoneindex].style.background = progressBarCss.emptyProgressBarLineColor;
            
            });
// const milestoneLabels = document.querySelectorAll(`.milestone__label .ac-discount`);
        milestone__labels.forEach((milestone, milestoneIndex) => {
          // const milestoneCircle = milestone.querySelector(`.${progressBarSelectorMap.circle}`);
          // milestoneCircle.style.background = progressBarCss.emptyProgressBarLineColor;
          // milestone__labels[milestoneindex].style.background = progressBarCss.emptyProgressBarLineColor;
          if (milestone.classList.contains('ac-discount-fill')) {
            milestone.classList.remove('ac-discount-fill');
            milestone.classList.add('ac-discountamount');
          }
        });


      tierValues.forEach((value, index) => {
        const minValue = parseFloat(tierMin[index], 10);
        const maxValue =
          tierMax[index] === "max" ? Infinity : parseFloat(tierMax[index], 10);
        
        if (compareQuantity >= minValue && compareQuantity <= maxValue) {
          const totalMilestones = tiers.tier_values.length;
           milestones.forEach((milestone, milestoneindex) => {
            if (index >= milestoneindex ) {
              const milestoneCircle = milestone.querySelector(`.${progressBarSelectorMap.circle}`);
              milestoneCircle.style.background = progressBarCss.fillProgressBarLineColor;
              milestone__labels[milestoneindex].style.background = progressBarCss.fillProgressBarLineColor;
                if (milestone__labels[milestoneindex].classList.contains('ac-discountamount')) {
                milestone__labels[milestoneindex].classList.remove('ac-discountamount');
                milestone__labels[milestoneindex].classList.add('ac-discount-fill');
                }
            }

            });
          // Ensure proper calculation for index 0
          progressFillWidth = index === 0 ? 0: totalMilestones > 1? (index / totalMilestones) * 100 : 100;
          progressFillWidth = tierValues.length > 1 ? (index / (tierValues.length - 1)) * 100 : 100;;
        }
      });
  
      // Update the progress bar fill width
      progressBarFill.style.width = `${progressFillWidth}%`;
  
      // Update milestone states dynamically
      milestones.forEach((milestone, index) => {
        const leftPosition = tierValues.length > 1 ? (index / (tierValues.length - 1)) * 100 : 100;
  
        const milestoneCircle = milestone.querySelector(`.${progressBarSelectorMap.circle}`);
        const minValue = parseFloat(tierMin[index], 10);
        const maxValue = tierMax[index] === "max" ? Infinity : parseFloat(tierMax[index], 10);
  
        // Add the icon inside the milestone circle
        milestoneCircle.innerHTML = `${progressBarSelectorMap.icon}`;
        const discountIcon = milestoneCircle.querySelector(".ri-truck-line");
  
        if (
          progressFillWidth >= leftPosition &&
          isInAnyRange(compareQuantity, tierMin, tierMax)
        ) {
          if (discountIcon) {
            milestoneCircle.style.background = progressBarCss.emptyProgressBarLineColor;
            discountIcon.style.color = progressBarCss.logoColor;

          }
        } else {
          if (discountIcon) {
            milestoneCircle.style.background = "#ffff";
            discountIcon.style.color = "#ddd";
          }
        }
      });
    }
  suggestQuantityForDiscount(compareQuantity,tierMin,tierMax,tierValues,tiers.discount_type,tiers.DiscountBasedOn);
  }

